import { render, staticRenderFns } from "./ChatFormComponent.vue?vue&type=template&id=7d3fecc6&"
import script from "./ChatFormComponent.vue?vue&type=script&lang=js&"
export * from "./ChatFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3fecc6')) {
      api.createRecord('7d3fecc6', component.options)
    } else {
      api.reload('7d3fecc6', component.options)
    }
    module.hot.accept("./ChatFormComponent.vue?vue&type=template&id=7d3fecc6&", function () {
      api.rerender('7d3fecc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatFormComponent.vue"
export default component.exports